/**
 * Modern Results Sections
 *
 * Phase 3: Mobile Results Optimization
 * Extracted from ModernResultsFull.tsx for modularity
 *
 * Phase 3.4: AccordionHeader for L3 collapsible sections
 */

export { IssuesSection, type IssuesSectionProps } from './IssuesSection';
export { SuggestionsSection, type SuggestionsSectionProps } from './SuggestionsSection';
export { PatternsSection, type PatternsSectionProps } from './PatternsSection';
export { GatedPatternsSection, type GatedPatternsSectionProps } from './GatedPatternsSection';
export { TransformationsSection, type TransformationsSectionProps } from './TransformationsSection';
export { FeedbackSection, type FeedbackSectionProps } from './FeedbackSection';
export { AccordionHeader } from './AccordionHeader';
